import React from "react";
import {
  Animated,
  FlatList,
  SectionList,
  FlatListProps,
  Text,
} from "react-native";
import { QUERY_UTIL } from "../libs/utils/dataUtils";
import ReAnimated from "react-native-reanimated";
import {
  SectionGrid,
  SectionGridProps,
  FlatGrid,
} from "react-native-super-grid";

type Props = {
  animated?;
  onScroll?;
  style?;
  scrollRef?;
  reAnimated?: boolean;
  superGrid?;
} & FlatListProps<any> &
  Partial<SectionGridProps<any>>;

const CustomFlatList = React.forwardRef((props: Props, ref: any) => {
  const {
    animated,
    onScroll,
    scrollRef,
    reAnimated = false,
    sections = null,
    superGrid = false,
  } = props;
  const extraProps = {};
  if (animated) {
    extraProps["onScroll"] = Animated.event(
      [
        {
          nativeEvent: {
            contentOffset: {
              y: scrollRef,
            },
          },
        },
      ],
      { useNativeDriver: false }
    );
  } else if (onScroll) {
    extraProps["onScroll"] = onScroll;
  }
  const FlatListView = reAnimated
    ? ReAnimated.FlatList
    : superGrid
    ? FlatGrid
    : FlatList;
  if (sections) {
    return (
      <SectionGrid
        ref={ref}
        sections={sections}
        showsVerticalScrollIndicator={false}
        showsHorizontalScrollIndicator={false}
        bounces={false}
        initialNumToRender={QUERY_UTIL.limit}
        alwaysBounceHorizontal={false}
        alwaysBounceVertical={false}
        spacing={0}
        {...props}
        {...extraProps}
      />
    );
  }
  return (
    <FlatListView
      ref={ref}
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
      bounces={false}
      initialNumToRender={QUERY_UTIL.limit}
      alwaysBounceHorizontal={false}
      alwaysBounceVertical={false}
      spacing={0}
      {...props}
      {...extraProps}
    />
  );
});


export default CustomFlatList;
